import React from 'react';

// Dizin yapısı
const DIRECTORY_STRUCTURE: { [key: string]: string[] } = {
  '~': ['about.txt', 'contact.txt', 'education.txt', 'experience.txt', 'projects/', 'skills/'],
  '~/projects': [],
  '~/skills': ['skills.txt'],
  '/': ['home/', 'usr/', 'bin/'],
};

// Path normalizasyonu
const normalizePath = (currentPath: string, targetPath: string): string => {
  if (!targetPath || targetPath === '~' || targetPath === '') {
    return '~';
  }
  
  if (targetPath.startsWith('/')) {
    return targetPath;
  }
  
  if (targetPath === '..') {
    if (currentPath === '~') return '~';
    if (currentPath.startsWith('~/')) {
      const parts = currentPath.split('/');
      if (parts.length === 2) return '~';
      return parts.slice(0, -1).join('/');
    }
    return '/';
  }
  
  if (targetPath.startsWith('~/')) {
    return targetPath;
  }
  
  // Relative path
  if (currentPath === '~') {
    return `~/${targetPath}`;
  }
  
  return `${currentPath}/${targetPath}`;
};

// Path'in geçerli olup olmadığını kontrol et
const isValidPath = (path: string): boolean => {
  if (path === '~' || path === '/') return true;
  if (path.startsWith('~/')) {
    const dir = path.substring(2);
    return dir === 'projects' || dir === 'skills';
  }
  return false;
};

export const executeCommand = (
  command: string,
  setCurrentPath: (path: string) => void,
  currentPath: string = '~',
  commandHistory: string[] = []
): string | React.ReactElement => {
  const cmd = command.toLowerCase().trim();
  const parts = cmd.split(' ');

  switch (parts[0]) {
    case 'help':
      return `Available commands:

  help              - Show this help message
  contact           - Show contact information
  about             - About me
  education         - Education background
  experience        - Work experience
  resume            - Resume summary
  skills            - Show technical skills
  clear             - Clear terminal screen
  whoami            - User information
  history           - Show command history
  ls                - List files
  pwd               - Show current directory
  cd [dir]          - Change directory
  echo [text]       - Print text
  cat [file]        - Display file contents

Type "help [command]" for more information.`;

    case 'contact':
      return `Contact Information:

  Email:    serhan@ergoren.tr
  LinkedIn: https://www.linkedin.com/in/serhan-erg%C3%B6ren-293b301b2/
  
  Feel free to reach out via email for job opportunities and collaborations.`;

    case 'about':
      return `Serhan Ergören

  Software developer, IT infrastructure manager, and technology enthusiast.
  I work with modern web technologies, software architecture, and IT 
  infrastructure management.
  
  I operate in London as the owner of Retinentia LTD.`;

    case 'clear':
      // Clear komutu Terminal bileşeninde handle ediliyor
      return '';

    case 'whoami':
      return 'user';

    case 'history':
      if (commandHistory.length === 0) {
        return 'No commands in history.';
      }
      return commandHistory.map((cmd, index) => 
        `  ${index + 1}  ${cmd}`
      ).join('\n');

    case 'skills':
      return `Technical Skills:

Networking & Infrastructure:
  • Juniper routers/switches
  • Cisco routers/switches
  • Huawei routers/switches
  • MikroTik routers/switches
  • BGP
  • Virtual networks
  • WireGuard
  • Datacenter solutions

Virtualization & Cloud:
  • Proxmox
  • VMware
  • Cloud hosting
  • WAF (Web Application Firewall)
  • Hosting solutions

Frontend Development:
  • React
  • React Native
  • Vue
  • Vite
  • Electron

Backend & Databases:
  • PHP
  • Laravel
  • CodeIgniter
  • PostgreSQL
  • Prisma
  • MySQL

Emerging Technologies:
  • LLM (Large Language Models)
  • Reverse Engineering

IoT & Embedded:
  • Arduino
  • IoT
  • Raspberry Pi`;

    case 'pwd':
      return currentPath === '~' ? '/home/user' : currentPath.replace('~', '/home/user');

    case 'cd':
      const targetPath = parts[1] || '~';
      const newPath = normalizePath(currentPath, targetPath);
      
      if (!isValidPath(newPath)) {
        return `cd: ${targetPath}: No such file or directory`;
      }
      
      setCurrentPath(newPath);
      return '';

    case 'ls':
      const dirContents = DIRECTORY_STRUCTURE[currentPath] || [];
      if (dirContents.length === 0) {
        return '';
      }
      return dirContents.join('\n');

    case 'echo':
      return parts.slice(1).join(' ') || '';

    case 'education':
    case 'edu':
      return `Education:

  Isparta University of Applied Sciences
  Mechatronics, Robotics, and Automation Engineering
  
  Anadolu University
  Computer Programming
  Network Management`;

    case 'experience':
    case 'exp':
      return `Work Experience:

  Retinentia LTD
  Company Owner
  May 2021 - Present (4+ years)
  London, United Kingdom
  
  • IT Infrastructure Management
  • Company management and operational processes`;

    case 'resume':
    case 'cv':
      return `Resume Summary:

  Serhan Ergören
  
  EXPERIENCE:
  Retinentia LTD - Company Owner (May 2021 - Present)
  London, United Kingdom
  IT Infrastructure Management
  
  EDUCATION:
  • Isparta University of Applied Sciences
    Mechatronics, Robotics, and Automation Engineering
  
  • Anadolu University
    Computer Programming, Network Management
  
  CONTACT:
  Email: serhan@ergoren.tr
  LinkedIn: https://www.linkedin.com/in/serhan-erg%C3%B6ren-293b301b2/`;

    case 'cat':
      if (parts[1] === 'about.txt') {
        return `Serhan Ergören

Software developer, IT infrastructure manager, and technology enthusiast.
I work with modern web technologies, software architecture, and IT 
infrastructure management.`;
      } else if (parts[1] === 'contact.txt') {
        return `Email: serhan@ergoren.tr
LinkedIn: https://www.linkedin.com/in/serhan-erg%C3%B6ren-293b301b2/`;
      } else if (parts[1] === 'education.txt') {
        return `Isparta University of Applied Sciences
Mechatronics, Robotics, and Automation Engineering

Anadolu University
Computer Programming
Network Management`;
      } else if (parts[1] === 'experience.txt') {
        return `Retinentia LTD - Company Owner
May 2021 - Present (4+ years)
London, United Kingdom

IT Infrastructure Management`;
      } else if (parts[1] === 'skills.txt') {
        return `Technical Skills:

Networking & Infrastructure:
  • Juniper routers/switches
  • Cisco routers/switches
  • Huawei routers/switches
  • MikroTik routers/switches
  • BGP
  • Virtual networks
  • WireGuard
  • Datacenter solutions

Virtualization & Cloud:
  • Proxmox
  • VMware
  • Cloud hosting
  • WAF (Web Application Firewall)
  • Hosting solutions

Frontend Development:
  • React
  • React Native
  • Vue
  • Vite
  • Electron

Backend & Databases:
  • PHP
  • Laravel
  • CodeIgniter
  • PostgreSQL
  • Prisma
  • MySQL

Emerging Technologies:
  • LLM (Large Language Models)
  • Reverse Engineering

IoT & Embedded:
  • Arduino
  • IoT
  • Raspberry Pi`;
      }
      return `cat: ${parts[1]}: File not found`;

    default:
      return `Command not found: ${command}
Type "help" to see available commands.`;
  }
};

